import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import { useIntl } from 'react-intl';
// import { useSelector } from 'react-redux';
// import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import ROUTES from 'routes/routeConstants';
import { CompanyRoleEnum, RoleEnum } from 'types/user';
import { formatMessage } from 'utils/IntlMessages';

export interface RouteDisplayValues {
  rolesAllowed: RoleEnum[] | RoleEnum;
  text: any;
  iconClass: string;
  matched_routes?: ROUTES[];
  blocked?: boolean;
}

export const useRoutesDisplayValues = (): Record<string, RouteDisplayValues> => {
  const intl = useIntl();
  const user = useCurrentLoggedInUser(); // test nha
  const userManagementPermission =
    user.usersLocations?.some((uL) => uL.manageUsersPermission) ||
    user.role === RoleEnum.ADMIN ||
    user.companyRole === CompanyRoleEnum.ADMIN;
  // const clientLocationPermissions = user.companyRole === CompanyRoleEnum.ADMIN;
  return {
    [ROUTES.DASHBOARD]: {
      rolesAllowed: [RoleEnum.ADMIN, RoleEnum.CLIENT],
      text: formatMessage(intl, 'sidebar.dashboard'),
      iconClass: 'icon icon-data-display',
    },
    [ROUTES.TRANSACTIONS]: {
      rolesAllowed: [RoleEnum.ADMIN, RoleEnum.CLIENT],
      text: formatMessage(intl, 'sidebar.transaction'),
      iconClass: 'icon icon-tasks',
      matched_routes: [ROUTES.TRANSACTION_CREATE],
    },
    [ROUTES.APPOINTMENTS]: {
      rolesAllowed: [RoleEnum.ADMIN],
      text: formatMessage(intl, 'sidebar.appointment'),
      iconClass: 'icon icon-hotel-booking',
    },
    [ROUTES.SERVICE_TYPES]: {
      rolesAllowed: [RoleEnum.ADMIN],
      text: formatMessage(intl, 'sidebar.serviceTypes'),
      iconClass: 'icon icon-refer',
    },
    [ROUTES.ACCOUNTINGS]: {
      rolesAllowed: [RoleEnum.ADMIN],
      text: formatMessage(intl, 'sidebar.accounting'),
      iconClass: 'icon icon-data-display',
      matched_routes: [ROUTES.ACCOUNTING_DETAIL],
    },
    [ROUTES.SYSTEM_LOG]: {
      rolesAllowed: [RoleEnum.ADMIN],
      text: formatMessage(intl, 'sidebar.systemLog'),
      iconClass: 'icon icon-hotel-booking',
    },
    [ROUTES.ACTIVE_APPOINTMENTS]: {
      rolesAllowed: [RoleEnum.NOTARY],
      text: formatMessage(intl, 'sidebar.activeAppointments'),
      iconClass: 'icon icon-hotel-booking',
    },
    [ROUTES.HISTORY_APPOINTMENTS]: {
      rolesAllowed: [RoleEnum.NOTARY],
      text: formatMessage(intl, 'sidebar.historyAppointments'),
      iconClass: 'icon icon-select',
    },
    [ROUTES.COMPANY_LOCATION]: {
      rolesAllowed: [RoleEnum.CLIENT],
      text: 'Office Locations',
      iconClass: 'icon icon-location',
      // blocked: !clientLocationPermissions,
    },
    [ROUTES.USERS]: {
      rolesAllowed: [RoleEnum.ADMIN, RoleEnum.CLIENT],
      text: formatMessage(intl, 'sidebar.usersRoles'),
      iconClass: 'icon icon-user',
      blocked: !userManagementPermission,
    },
  };
};
